import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {GalleryImageState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class GalleryImageQuery extends QueryEntity<GalleryImageState> {

  constructor(protected store: Store) {
    super(store);
  }

}
